import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { MARKET, CLEAR_MARKET } from 'actions/localMarkets';

const INITIAL_STATE = Immutable({
  loading: false,
  data: {},
  error: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${MARKET}_LOADING`:
      return state.merge({ loading: true, error: null });
    case `${MARKET}_ERROR`:
      return state.merge({
        loading: false,
        error: action.payload,
      });
    case `${MARKET}`:
      return state.merge(
        {
          loading: false,
          data: { [action.meta.id]: action.payload },
          error: null,
        },
        { deep: true },
      );
    case CLEAR_MARKET:
      return state.merge({
        loading: false,
        data: {},
        error: null,
      });
    default:
      return state;
  }
};
